import React from 'react';
import PropTypes from 'prop-types';
import { Draggable } from '@hello-pangea/dnd';
import { DndDropIcon } from '../Icons/Icons';
import { getItemClassNames } from '../../utils/siteDetailsTabs';

const Tab = ({
  title,
  onClick,
  isActive,
  length = 0,
  isDraggable = false,
  isDragDisabled = false,
  draggableIndex = 0,
}) => {
  const conditionalClass = () => {
    if (isActive && !isDraggable) {
      return 'text-vamos-black border-b-2 border-vamos-green1 font-bold hover:text-vamos-black whitespace-nowrap';
    }
    if (isDraggable) {
      return 'text-inherit font-bold whitespace-nowrap';
    }
    return 'text-vamos-gray whitespace-nowrap';
  };
  // to apply DnD (not just DndDropIcon) we cannot use button tag, so need to use div as button
  const tabContent = (
    <div
      className={`p-3 text-xl ${conditionalClass()}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClick(e);
        }
      }}
      data-testid={`${title.toLowerCase()}-tab`}
    >
      {title} {length > 0 && `(${length})`}
    </div>

  );

  return isDraggable ? (
    <Draggable
      key={title}
      draggableId={title}
      isDragDisabled={isDragDisabled}
      index={draggableIndex}
    >
      {(provided, snapshot) => (
        // to apply DnD to whole tab (not just DndDropIcon) we cannot use button tag, so need to use div as button
        (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            className={`flex flex-col ${getItemClassNames(snapshot.isDragging)}`}
            onMouseDown={onClick}
            role="button"
            tabIndex={0}
          >
            <DndDropIcon className="w-full flex items-center justify-center text-inherit" />
            {tabContent}
          </div>
        )

      )}
    </Draggable>
  ) : (
    tabContent

  );
};

Tab.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
  length: PropTypes.number,
  isDraggable: PropTypes.bool,
  isDragDisabled: PropTypes.bool,
  draggableIndex: PropTypes.number,

};

export default Tab;
